import { gql } from '@apollo/client'
import { PLAYBOOK_FRAGMENT } from 'gql/fragments/PlaybookFragment'

export const PLAYBOOK = gql`
  query getPlaybook($playbookSlug: String!) {
    scoPlaybook(slug: $playbookSlug) {
      ...PlaybookFragment
    }
  }
  ${PLAYBOOK_FRAGMENT}
`
